import React from "react";
import { AlertTriangle } from 'lucide-react';

const ConfirmDeletePopup = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50" dir="rtl">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onCancel} />
      
      {/* Modal */}
      <div className="relative bg-gray-900 w-full max-w-md rounded-2xl shadow-xl overflow-hidden border border-gray-800 mx-4">
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-12 rounded-full bg-red-500/10 flex items-center justify-center">
              <AlertTriangle className="w-6 h-6 text-red-500" />
            </div>
            <h2 className="text-2xl font-bold text-white">هل أنت متأكد؟</h2>
          </div>

          {/* Message */}
          <p className="text-gray-300 leading-relaxed mb-8">
            {message}
          </p>

          {/* Actions */}
          <div className="flex gap-3 justify-end">
            <button
              onClick={onCancel}
              className="px-4 py-2.5 rounded-lg bg-gray-800 text-white hover:bg-gray-700 transition-colors font-medium"
            >
              إلغاء
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2.5 rounded-lg bg-red-500 text-white hover:bg-red-600 transition-colors font-medium"
            >
              تأكيد
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeletePopup;